export default "__VITE_ASSET__Bls8VCCo__"